import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';

import * as styles from './text-highlights.module.scss';

const TextHighlight = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Row className={clsx(styles.titleHighlights, `row-cols-${Math.floor(list?.length/2)} row-cols-xl-${list?.length}`)}>
            {list.map(item => (
              <div className={clsx('col text-center')} key={item.id}>
                {(item.showTitle && item.title) && <Heading type='h2' className={styles.title}>{item.title}</Heading>}
                <RichText json={item.text} p='fs-24 fw-medium'/>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default TextHighlight
